import { DateTime } from 'luxon';

export enum DateFormatType {
  Date,
  DateTime,
}

export class DateFormatter {
  private static readonly _dateTimeFormat = 'yyyy. MM. dd. HH:mm:ss';
  private static readonly _dateFormat = 'yyyy. MM. dd.';

  public static format(isoDateString: string, formatType: DateFormatType, customFormat?: string): string {
    if (!isoDateString) {
      return '';
    }

    let date = DateTime.fromISO(isoDateString);
    if (date == null || !date.isValid) {
      return '';
    }

    switch (formatType) {
      case DateFormatType.DateTime:
        return date.toFormat(this._dateTimeFormat);
      case DateFormatType.Date:
        return date.toFormat(this._dateFormat);
      default:
        return '';
    }
  }
}

export default { DateFormatter, DateFormatType };
